import React, { Component } from 'react'

import PageNotFound from './PageNotFound'

// redux
import { connect } from 'react-redux'

import { type } from '../constants/QBActionsConst'

const mapStateToProps = state => {
    return {
        user: state.auth.userInfo
    }
}

const mapDispatchToProps = dispatch => {
    return {

    }
}

const Authorization = (allowedRoles) => (WrappedComponent) => {
    return connect(mapStateToProps, mapDispatchToProps)(
        class WithAuthorization extends Component {
            render() {
                const { user } = this.props
                let auth = false

                if (allowedRoles.includes(type.ALL)) {
                    auth = true;
                }

                if (allowedRoles.includes(type.ONLY_SUPER_ADMIN)) {
                    if (user && user.tier_id === 100)
                        auth = true;
                    else
                        auth = false;
                }

                // check tier 1, 2, 3 view report screen 
                if (allowedRoles.includes(type.REPORT_VIEW)) {
                    if (user && user.tier_id >= 1 && user.tier_id <= 3){
                        auth = true;
                    }
                }

                if (user) {
                    const actions = user.actions ? user.actions : []
                    for (let index = 0; index < actions.length; index++) {
                        let action = actions[index]
                        if (allowedRoles.includes(action)) {
                            auth = true;
                            break;
                        }
                    }
                }

                if (auth)
                    return <WrappedComponent {...this.props} />
                else
                    return <PageNotFound {...this.props} />
            }
        }
    )
}

export default Authorization